<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import Select from '$components/Form/Select.svelte';
    import MeltMultiSelect from '$components/Form/MeltMultiSelect.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import Textarea from '$components/Form/Textarea.svelte';
    import find from 'lodash/find';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const projectTypeOptions = [
        `Construction résidentielle`,
        `Bâtiment tertiaire (bureaux, commerces)`,
        `Chantier industriel`,
        `Projet minier`,
        `Travaux publics / routes`,
        `Agricole / aménagement rural`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const equipmentTypesOptions = [
        `Engins lourds (bulldozer, pelle hydraulique, niveleuse…)`,
        `Matériel de construction (bétonnière, compacteur, plaque vibrante…)`,
        `Équipements de coffrage (bois, accessoires, signalisation…)`,
        `Matériel de levage (grue, chariot télescopique, nacelle…)`,
        `Véhicules de chantier (camion-benne, utilitaires BTP…)`,
        `Outils électroportatifs (marteau piqueur, perceuses…)`,
        `Équipements industriels, agricoles ou miniers`,
    ].map((v) => ({ label: v, value: v }));

    const purchaseModeOptions = [`Acheter`, `Louer`, `Les deux, selon le matériel`].map(
        (v) => ({ label: v, value: v, key: v }),
    );

    const additionalServicesOptions = [
        `Entretien & maintenance`,
        `Livraison & installation`,
        `Formation du personnel`,
        `Assistance technique sur site`,
        `Aucun service supplémentaire`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.materielsBTP.projectType}
        class=""
        let:field
        let:id
        label={`Quel type de projet de construction ou d'infrastructure envisagez-vous ?`}
    >
        <Select
            {form}
            {field}
            {id}
            required={false}
            options={projectTypeOptions}
            placeholder="Sélectionnez un type de projet"
        />
    </Row>

    <Row
        {form}
        field={fields.materielsBTP.equipmentTypes}
        class=""
        let:field
        let:id
        label={`Quels types d'équipements ou de matériels recherchez-vous spécifiquement ?`}
    >
        <MeltMultiSelect
            {form}
            {field}
            {id}
            placeholder=""
            options={equipmentTypesOptions}
            valueToOption={(v) => ({
                value: v,
                label: find(equipmentTypesOptions, (o) => o.value === v)?.label ?? '',
            })}
        />
    </Row>

    <Row
        {form}
        field={fields.materielsBTP.purchaseMode}
        class=""
        let:field
        let:id
        label={`Souhaitez-vous acheter ou louer vos équipements ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-3 gap-x-6 gap-y-1"
            choices={purchaseModeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.materielsBTP.additionalServices}
        class=""
        let:field
        let:id
        label={`Avez-vous besoin de services complémentaires ? (cases à cocher)`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={additionalServicesOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
